<script>
    /**
     * SPDX-FileCopyrightText: 2012-2026 Open Assessment Technologies S.A.
     * Copyright (C) 2026 (original work) Open Assessment Technologies S.A.
     *
     * SPDX-License-Identifier: AGPL-3.0-only OR LicenseRef-TAO-Commercial-License
     */
    import GraphicGapMatchInteraction from '../../../interactions/graphic/graphicGapMatch/GraphicGapMatchInteraction.svelte';

    let props = $props();

    function prepareClasses(classes = '') {
        let classList = classes.split(' ');

        // add review mode indicator class
        classList.push('qti-reviewInteraction');

        return classList.join(' ');
    }

    let newProps = $derived(
        Object.assign({}, props, {
            classes: prepareClasses(props.classes),
            disabled: true
        })
    );
</script>

<GraphicGapMatchInteraction {...newProps} />
